<div class="desktop">
  <a uiLink [link]="shoppingListUrl()">
    <ui-icon-button
      tooltip="Einkaufsliste ansehen"
      tooltipPosition="above"
      buttonStyle="unthemed"
      icon="eye"
      iconStyle="light"
    ></ui-icon-button>
  </a>
  <ui-icon-button
    (clicked)="deleteClicked()"
    tooltip="Einkaufsliste löschen"
    tooltipPosition="above"
    buttonStyle="unthemed"
    icon="trash"
    iconStyle="light"
  ></ui-icon-button>
</div>
<div class="mobile">
  <a uiLink [link]="shoppingListUrl()">
    <ui-button buttonStyle="text" icon="eye" iconStyle="light">Einkaufsliste ansehen
    </ui-button>
  </a>
  <ui-button (clicked)="deleteClicked()" buttonStyle="text" icon="trash" iconStyle="light">Einkaufsliste löschen
  </ui-button>
</div>
